<template>
	<v-chip x-small label outlined :color="stato.colore" :title="item.status === 'failed' ? item.error : ''">
		<v-progress-circular v-if="item.status === 'generating'" indeterminate size="10" width="2" class="mr-1"></v-progress-circular>
		{{ stato.testo }}
	</v-chip>
</template>

<script>
const STATI = {
	draft: { testo: 'Bozza', colore: 'grey' },
	generating: { testo: 'In generazione', colore: 'primary' },
	ready: { testo: 'Pubblicato', colore: 'success' },
	failed: { testo: 'Non riuscito', colore: 'error' },
};

export default {
	name: 'FlyerStatusChip',
	props: {
		item: { type: Object, required: true },
	},
	computed: {
		stato() {
			return STATI[this.item.status] || STATI.draft;
		},
	},
};
</script>
